import { lazy, Suspense } from "react";
import { Outlet } from "react-router-dom";
import { AuthGuard } from "src/auth/guard";
import { LoadingScreen } from "src/components/loading-screen";
import DefaultLayout from "src/layouts/default";
import { paths } from "src/routes/paths";

// ----------------------------------------------------------------------

const SendNotificationView = lazy(
  () => import("src/sections/push-notifications/send/view")
);
const EditNotificationView = lazy(
  () => import("src/sections/push-notifications/edit/view")
);
const NotificationHistoryView = lazy(
  () => import("src/sections/push-notifications/history/view")
);

// ----------------------------------------------------------------------

export const pushNotificationsRoutes = [
  {
    element: (
      <AuthGuard>
        <DefaultLayout>
          <Suspense fallback={<LoadingScreen />}>
            <Outlet />
          </Suspense>
        </DefaultLayout>
      </AuthGuard>
    ),
    children: [
      {
        path: paths.pushNotifications.root,
        element: <NotificationHistoryView />,
      },
      {
        path: paths.pushNotifications.detail.send,
        element: <SendNotificationView />,
      },
      {
        path: paths.pushNotifications.detail.edit,
        element: <EditNotificationView />,
      },
    ],
  },
];
